import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

const BLOCKING_MESSAGES = {
  recording: {
    title: 'Recording in Progress',
    icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    message: 'Your recording is still active. If you leave now:',
    risks: [
      'Recording will be stopped gracefully',
    //   'Current transcript will be saved as draft',
    //   'Manual notes will be auto-saved'
    ],
    confirmText: 'Stop Recording & Leave',
    cancelText: 'Stay on Page'
  },
  uploading: {
    title: 'Upload in Progress',
    icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    message: 'Transcript upload is in progress. Leaving now may interrupt the upload.',
    risks: [
      'Upload may be incomplete',
      'You may need to re-upload the transcript'
    ],
    confirmText: 'Leave Anyway',
    cancelText: 'Wait for Upload'
  },
  bulk_import: {
    title: 'Bulk Import in Progress',
    icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    message: 'Clinician bulk import is currently processing. If you leave now:',
    risks: [
      'Import process may be interrupted',
      'Some clinicians may not be imported',
      'You may need to re-import the CSV file'
    ],
    confirmText: 'Leave Anyway',
    cancelText: 'Wait for Import'
  },
  generating: {
    title: 'AI Notes Generating',
    icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
    message: 'AI notes are being generated. The process will continue in the background.',
    risks: [
      'You can return later to view the completed notes',
      'Manual notes will be auto-saved'
    ],
    confirmText: 'Leave',
    cancelText: 'Stay on Page'
  }
};

const NavigationConfirmModal = ({
  visible,
  blockingReason,
  onConfirm,
  onCancel,
  loading = false
}) => {
  const config = BLOCKING_MESSAGES[blockingReason] || BLOCKING_MESSAGES.recording;

  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {config.icon}
          <span style={{ fontSize: 16, fontWeight: 600 }}>{config.title}</span>
        </div>
      }
      onOk={onConfirm}
      onCancel={onCancel}
      okText={config.confirmText}
      cancelText={config.cancelText}
      okButtonProps={{ 
        danger: blockingReason === 'recording' || blockingReason === 'uploading' || blockingReason === 'bulk_import',
        loading 
      }}
      cancelButtonProps={{ type: 'default' }}
      centered
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
      destroyOnClose
      width={480}
    >
      <div style={{ paddingTop: 16 }}>
        <p style={{ 
          fontSize: 14, 
          color: '#595959', 
          marginBottom: 16,
          lineHeight: 1.6 
        }}>
          {config.message}
        </p>
        
        <ul style={{ 
          margin: 0, 
          paddingLeft: 20,
          listStyleType: 'disc'
        }}>
          {config.risks.map((risk, index) => (
            <li 
              key={index} 
              style={{ 
                fontSize: 14, 
                color: '#595959',
                marginBottom: 8,
                lineHeight: 1.5
              }}
            >
              {risk}
            </li>
          ))}
        </ul>

        {blockingReason === 'recording' && (
          <div style={{
            marginTop: 16,
            padding: 12,
            backgroundColor: '#fff7e6',
            border: '1px solid #ffd591',
            borderRadius: 4
          }}>
            <p style={{ 
              margin: 0, 
              fontSize: 13, 
              color: '#ad6800',
              fontWeight: 500
            }}>
              ⚠️ Your recording session will end if you proceed.
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default NavigationConfirmModal;
